<template>
    <div class="pos-items">
        <div class="pos-items-scroll">
            <table class="table create-billing pos-items-table">
                <thead>
                    <tr>
                        <th class="pl-10 particular">Item Details</th>
                        <th>Last P. Rate</th>
                        <th>Stock</th>
                        <th class="qty">Qty</th>
                        <th class="rate">Rate</th>
                        <th class="sub-amount">Amount</th>
                        <th class="discount">Dis(%)</th>
                        <th class="d-amount">Dis</th>
                        <th class="after-amount">After Dis.</th>
                        <th class="vat">VAT(%)</th>
                        <th class="vat-amount">VAT Amt</th>
                        <th class="total">Total</th>
                        <th class="th-action"></th>
                    </tr>
                </thead>

                <tbody ref="tableRef">
                    <RowInline
                        v-for="(item, i) in tableItems" :key="item.id"
                        :item="item" :index="i"
                        :vatRate="vatRate"
                        @onOpenEditItem="onOpenEditItem"
                        @onDeleteItem="onDeleteItem"
                    />
                </tbody>
            </table>
            <div v-if="! tableItems.length" class="empty-state">
                <i class="fa fa-barcode empty-icon"></i>
                <p class="empty-title">No items yet</p>
                <p class="empty-hint">Scan a barcode or search a product to start billing</p>
            </div>
        </div>
    </div>
</template>

<script setup>    
    import RowInline from '@/components/molecule/company/hospital/general-billing/v2/InvoiceTableRow.vue';
    import useDetectOutsideClick from '@/services/useDetectOutsideClick';
    import { ref } from 'vue';
    
    const tableRef = ref(null)

    const props = defineProps({
        vatRate: {
            type: Array
        },
        tableItems: {
            type: Array
        }
    })

    useDetectOutsideClick(tableRef, () => {
        resetItemList();
    })
    
    const onOpenEditItem = (index) => {
        resetItemList(index);
    }

    const onDeleteItem = (index) => {
        props.tableItems.splice(index, 1);
    }

    const resetItemList = (selectedIndex = -1) => {
        for(let i = 0; i < props.tableItems.length; i++){
            
            if(selectedIndex === i){
                props.tableItems[i].isEdit = true;
                continue;
            }
            props.tableItems[i].isEdit = false;
        }
    }
</script>

<style>
.price-adj{
    display: flex;
    align-items: center;
}

.discount-adj{
    width: 60%;
}

.create-billing > :not(first-child) > * {
    padding-left: 10px !important;
}

.table-totals{
    font-weight: bold;
}
.product{
    width: 60%;
}
.comma-sep{
    text-align: right;
}

.create-billing > :not(caption) > * > * {
    padding: 0.72rem 0.2rem;
}
.particular{
    width: 25%;
}
.qty{
    width: 6%;
}
.discount{
    width: 5%;
}


.card-height{
    min-height: 200px
}

.add-new-line {
    margin-top: 4%;
}
</style>

<style scoped>
.pos-items {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
}
.pos-items-scroll {
    flex: 1;
    overflow: auto;
    display: flex;
    flex-direction: column;
}
.pos-items-table {
    margin-bottom: 0;
}
.pos-items-table thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #f8fafc;
    color: #667085;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    white-space: nowrap;
    border-bottom: 1px solid #e3e8ef;
    padding: 10px 8px !important;
}
.pos-items-table :deep(tbody td) {
    font-size: 13px;
    color: #344054;
    vertical-align: middle;
    border-bottom: 1px solid #eef2f6;
    padding: 8px !important;
}
.pos-items-table :deep(tbody tr:hover) {
    background: #f5f8ff;
    cursor: pointer;
}
.pos-items-table :deep(tbody h6) {
    font-size: 13px;
    margin-bottom: 0;
    color: #101828;
}
.pos-items-table :deep(tbody .form-control) {
    font-size: 13px;
    height: 34px;
    min-width: 64px;
}
.pos-items-table :deep(.btn-dlt) {
    color: #b42318;
}
.empty-state {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 16px;
    color: #98a2b3;
}
.empty-icon {
    font-size: 40px;
    margin-bottom: 12px;
    opacity: 0.5;
}
.empty-title {
    font-size: 15px;
    font-weight: 600;
    color: #667085;
    margin-bottom: 2px;
}
.empty-hint {
    font-size: 12px;
    margin-bottom: 0;
}
</style>